<template>
  <clinician-app-layout>
    <div class="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-6">
      <div class="pb-5 sm:flex sm:items-center sm:justify-between">
        <h2 class="text-3xl text-vice-teal-900 font-semibold leading-tight">
          Connected devices list
        </h2>
      </div>
      <div>
        <div
          v-for="(device, index) in connectedDevicesList"
          :key="index"
          class="relative overflow-x-auto"
        >
          <p class="text-xl font-bold">{{ index + 1 }}. {{ device.label }}</p>
          <ul class="mb-6">
            <li>
              <div class="grid grid-cols-12">
                <div class="font-semibold">Label:</div>
                <div class="col-span-11 text-gray-600">{{ device.label }}</div>
              </div>
            </li>
            <li>
              <div class="grid grid-cols-12">
                <div class="font-semibold">Kind:</div>
                <div class="col-span-11 text-gray-600">{{ device.kind }}</div>
              </div>
            </li>
            <li>
              <div class="grid grid-cols-12">
                <div class="font-semibold">Device ID:</div>
                <div class="col-span-11 text-gray-600">{{ device.deviceId }}</div>
              </div>
            </li>
            <li>
              <div class="grid grid-cols-12">
                <div class="font-semibold">Group ID:</div>
                <div class="col-span-11 text-gray-600">{{ device.groupId }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </clinician-app-layout>
</template>

<script>
import { watch, ref, onMounted } from 'vue';
import useDeviceAndSessionSetupStore from '@/Stores/useDeviceAndSessionSetupStore';
import ClinicianAppLayout from '@/Layouts/ClinicianAppLayout.vue';

export default {
  name: 'DeviceAndSessionSetup',
  components: {
    ClinicianAppLayout,
  },
  setup() {
    const connectedDevicesList = ref([]);
    const deviceAndSessionSetupStore = useDeviceAndSessionSetupStore();

    onMounted(() => {
      connectedDevicesList.value = deviceAndSessionSetupStore.getConnectedDevices();
    });

    watch(
      () => deviceAndSessionSetupStore.getConnectedDevices(),
      (devicesList) => {
        connectedDevicesList.value = devicesList;
      },
    );

    return {
      connectedDevicesList,
    };
  },
};
</script>

<style scoped></style>
